import Button from '@componentsNew/Button';
import Typography from '@componentsNew/Typography';

export const SelecioneArtigos = () => {
  return (
    <div className="flex flex-col gap-4 items-center justify-center">
      <Typography component="h4" className="text-center">
        Por favor, selecione os artigos que deseja importar para que possamos concluir a
        configuração e prosseguir com as análises.
      </Typography>

      <Button
        className="w-[18.938em]"
        onClick={() => {
          window.location.href = `${window.location.origin}/wp-admin/admin.php?page=optimarketing`;
        }}
      >
        <Typography component="button">Escolher Artigos</Typography>
      </Button>
    </div>
  );
};
